export default function Pagination(props) {
  const { filters, totalRecords, currentLoadedCount, wrapperClasses, filterChangeHook } = props;

  const startIndex = (filters.rpp * (filters.page - 1)) + 1
  const endIndex = startIndex + currentLoadedCount - 1
  const totalPage = Math.ceil(totalRecords / filters.rpp)
  const rppOptions = props.rppOptions ?? [5, 10, 20, 30, 40, 50]

  const onFilterChange = (filter) => {
    filterChangeHook({ ...filters, ...filter })
  }

  return (
    <div className={`${wrapperClasses} w-80`}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <div className="d-flex flex-row align-items-center">
          <span>Show</span>
          <select className="d-inline-block custom-select bg-white mx-3" value={filters.rpp} onChange={(a) => onFilterChange({ page: 1, rpp: a.target.value })}>
            {rppOptions.map((option) => option === 'All' ? <option value={999999999999999}>{option}</option> : <option value={option}>{option}</option>)}
          </select>
          <span className="text-nowrap">entries of {totalRecords} ({startIndex} to {endIndex})</span>
        </div>
        <ul className="pagination pagination-sm mr-6">
          {filters.page > 1 ?
            [<li className="page-item" onClick={() => onFilterChange({ page: 1 })}><button type='button' className="page-link" href="#">First</button></li>,
            <li className="page-item" onClick={() => onFilterChange({ page: filters.page - 1 })}>
              <button type='button' className="page-link" href="#">Prev</button>
            </li>]
            :
            [<li className="page-item disabled"><button type='button' className="page-link" href="#">First</button></li>,
            <li className="page-item disabled"><button type='button' className="page-link" href="#">Prev</button></li>]
          }

          {filters.page < totalPage ?
            [<li className="page-item" onClick={() => onFilterChange({ page: filters.page + 1 })}>
              <button type='button' className="page-link" href="#">Next</button>
            </li>,
            <li className="page-item" onClick={() => onFilterChange({ page: totalPage })}><button type='button' className="page-link" href="#">Last</button></li>]
            :
            [<li className="page-item disabled"><button type='button' className="page-link" href="#">Next</button></li>,
            <li className="page-item disabled" ><button type='button' className="page-link" href="#">Last</button></li>]
          }
        </ul>
      </div>
    </div>
  )
}